import { DesignElementSnapshotReason } from "@supernova-studio/model";
import { z } from "zod";
import { DTODocumentationPageV2 } from "../elements/documentation/page-v2";

export const DTODocumentationPageSnapshot = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),

  createdAt: z.string(),
  updatedAt: z.string(),

  documentationPage: DTODocumentationPageV2,
  pageContentHash: z.string(),

  reason: DesignElementSnapshotReason,
});

export type DTODocumentationPageSnapshot = z.infer<typeof DTODocumentationPageSnapshot>;
